export const EXTRA_SMALL_WIDTH = 580;
export const SMALL_WINDOW_WIDTH = 640;
export const TABLET_WINDOW_WIDTH = 768;
export const MEDIUM_WINDOW_WIDTH = 992;
export const LARGE_WINDOW_WIDTH = 1440;
export const EXTRA_LARGE_WINDOW_WIDTH = 1600;

export const MEDIUM_WINDOW_HEIGHT = 720;
